/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RegistrationPageImageResponse } from '../models/RegistrationPageImageResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RegistrationPageImageService {

    /**
     * API to upload or update registration page image (Admin only)
     * @param type Registration page type (1-11)
     * @param formData
     * @returns string Success
     * @throws ApiError
     */
    public static registrationPageImageUploadOrUpdateRegistrationPageImage(
        type?: number,
        formData?: {
            file?: Blob;
        },
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/registrationPageImage',
            query: {
                'type': type,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get all registration page images (Public)
     * @returns RegistrationPageImageResponse Success
     * @throws ApiError
     */
    public static registrationPageImageGetAllRegistrationPageImages(): CancelablePromise<Array<RegistrationPageImageResponse>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/registrationPageImage',
            errors: {
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get registration page image by type (Public)
     * @param type Registration page type (1-11)
     * @returns RegistrationPageImageResponse Success
     * @throws ApiError
     */
    public static registrationPageImageGetRegistrationPageImageByType(
        type: number,
    ): CancelablePromise<RegistrationPageImageResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/registrationPageImage/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to delete (soft delete) registration page image by type (Admin only)
     * @param type Registration page type (1-11)
     * @returns any Success
     * @throws ApiError
     */
    public static registrationPageImageDeleteRegistrationPageImage(
        type: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/registrationPageImage/{type}',
            path: {
                'type': type,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }

}
